module.exports = __webpack_public_path__ + "img/edit-note.be0237fb.png";